import { Box, Divider } from '@mui/material';
import { LWModal, ModalPanelBody } from 'redesign';
import { useCallback } from 'react';
import { ShiftDetailHead } from 'shared/components/shift-detail-modal/components/shift-detail-head/shift-detail-head';
import { useOgpGetShiftDetailsTabs } from 'shared/components/shift-detail-modal/hooks/ogp/use-ogp-get-shift-detail-tabs';
import { useGetShiftDetailHeadActions } from 'shared/components/shift-detail-modal/hooks/use-get-shift-detail-head-actions';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { useIsHqImpersonation } from 'shared/hooks';
import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';
import { useOgpCompanyTypeContext } from 'ogp/limited-company-capabilities';
import { usePlanningParamsContext } from '../../providers/planning-params-provider';
import { usePlanningContext } from '../../providers/planning-actions-provider';

type ShiftDetailsModalProps = {
  data: ShiftDetail;
};

export const ShiftDetailsModal = ({ data }: ShiftDetailsModalProps) => {
  const shiftDetailTabs = useOgpGetShiftDetailsTabs(data);
  const isHqAdmin = useIsHqImpersonation();
  const featureFlags = useFeatureFlagContext();
  const { setFilters } = usePlanningParamsContext();
  const { setSidebarState, handleSelectionChange } = usePlanningContext();
  const showTempWorkRate = isHqAdmin || featureFlags.allowGrossHourlyRateVisibleInOgp;
  const { isLimitedCompany } = useOgpCompanyTypeContext();
  const closeShiftDetail = useCallback(() => {
    setFilters({ shiftId: undefined });
  }, [setFilters]);

  const { children: shiftDetailHeadActions, isArchiving } = useGetShiftDetailHeadActions({
    data,
    closeModal: closeShiftDetail,
    setShiftAction: (action, shiftId) => {
      setSidebarState(action);
      handleSelectionChange([shiftId]);
    },
  });

  return (
    <LWModal isOpen={true} onClose={closeShiftDetail} testId="shift-detail">
      <Box p={8} height="100%" display="flex" flexDirection="column">
        <ShiftDetailHead
          close={closeShiftDetail}
          data={data}
          actions={shiftDetailHeadActions}
          isArchiving={isArchiving}
          showTempWorkRate={showTempWorkRate}
          hideLimitedCompanyShiftFields={isLimitedCompany}
        />
        <Box mt={8} mb={8}>
          <Divider />
        </Box>
        <ModalPanelBody tabs={shiftDetailTabs} />
      </Box>
    </LWModal>
  );
};
